
export function Colors_TorghattenBlueWithOpacity(opacity) {
    if (opacity > 1) {
        throw new Error(`Invalid opacity input: ${opacity} is over 1.0`);
    }
    else if (opacity < 0) {
        throw new Error(`Invalid opacity input: ${opacity} is under 0.0`);
    }
    else {
        return `rgba(14, 45, 122, ${opacity})`;
    }
}

export function Colors_TorghattenRedWithOpacity(opacity) {
    if (opacity > 1) {
        throw new Error(`Invalid opacity input: ${opacity} is over 1.0`);
    }
    else if (opacity < 0) {
        throw new Error(`Invalid opacity input: ${opacity} is under 0.0`);
    }
    else {
        return `rgba(227, 19, 30, ${opacity})`;
    }
}

//# sourceMappingURL=Design.js.map
